import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PayrollService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllPayrolls(page, size, startDate, endDate, personId,workingStatus,departmantId) {
    let queryParams = `page=${page}&size=${size}`;

    if(departmantId){
      queryParams += `&DepartmantId=${departmantId}`;
  
    }
    if (startDate) {
      queryParams += `&StartDate=${startDate}`;
    }
    if (endDate) {
      queryParams += `&EndDate=${endDate}`;
    }
    if (personId)
      queryParams += `&PersonId=${personId}`;
    if (workingStatus)
      queryParams += `&workingStatus=${workingStatus}`;

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Payroll,
      queryString:queryParams
    });
    return await firstValueFrom(observable);
  }

  async getAllPayrollByIdPersonList(page, size, search, personId) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Payroll,
      queryString: `Page=${page}&Size=${size}&Search=${search}&PersonId=${personId}`,
      action: "GetByIdPersonPayrolls"
    });
    return await firstValueFrom(observable);
  }

  async createPayroll(payroll) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Payroll
    }, {
      personId: payroll.personId,
      salaryPaymentDate: payroll.salaryPaymentDate,
      fM2Hours: payroll.fM2Hours,
      fM3Hours: payroll.fM3Hours,
      fmTotalEarnings: payroll.fmTotalEarnings,
      eK2Earnings: payroll.eK2Earnings,
      transportationAllowance: payroll.transportationAllowance,
      totalDays: payroll.totalDays,
      sickLeaveDays: payroll.sickLeaveDays,
      paidDays: payroll.paidDays,
      unpaidDays: payroll.unpaidDays,
      annualLeaveDays: payroll.annualLeaveDays,
      monthlyNetPaid: payroll.monthlyNetPaid,
      garnishmentDeduction: payroll.garnishmentDeduction,
      advanceDeduction: payroll.advanceDeduction,
      besContribution: payroll.besContribution,
      netAfterBes: payroll.netAfterBes,
      grossSalary:payroll.grossSalary
    });

    return await firstValueFrom(observable);
  }

  async updatePayroll(id, payroll) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Payroll
    }, {
      id: id,
      personId: payroll.personId,
      salaryPaymentDate: payroll.salaryPaymentDate,
      fM2Hours: payroll.fM2Hours,
      fM3Hours: payroll.fM3Hours,
      fmTotalEarnings: payroll.fmTotalEarnings,
      eK2Earnings: payroll.eK2Earnings,
      transportationAllowance: payroll.transportationAllowance,
      totalDays: payroll.totalDays,
      sickLeaveDays: payroll.sickLeaveDays,
      paidDays: payroll.paidDays,
      unpaidDays: payroll.unpaidDays,
      annualLeaveDays: payroll.annualLeaveDays,
      monthlyNetPaid: payroll.monthlyNetPaid,
      garnishmentDeduction: payroll.garnishmentDeduction,
      advanceDeduction: payroll.advanceDeduction,
      besContribution: payroll.besContribution,
      netAfterBes: payroll.netAfterBes,
      grossSalary:payroll.grossSalary
    });

    return await firstValueFrom(observable);
  }

  async createPayrollsExcel(payrolls){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.Payroll,
      action:"CreatePayrollsExcel"
    },payrolls);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
